import React from "react";
// import "./navbar.css";
import { useNavigate } from "react-router-dom";
import { FaHome, FaUser, FaBlog, FaEnvelope, FaProjectDiagram } from "react-icons/fa";

const Navbar = () => {
  const navigate = useNavigate();
  const goToProjects = () => {
    navigate('/', { state: { scrollTo: 'projects' } });
  };
  return (
    // <div className="bg-gradient-to-br from-[#edf6f9] via-[#d8f3dc] to-[#f1faee] pt-2 pb-2">
      <div className="bg-blue-100 pt-4 pb-2">

      {/* <nav className=" p-2 w-min content-center bg-[#9eeeed] rounded-full mx-auto" > */}
      <nav
        className="w-fit mx-auto px-8 py-3 rounded-full
                  bg-white/20 backdrop-blur-lg
                  border border-white/30
                  shadow-xl
                 "
      >
        <div className="navbar-logo">{/* Logo or Brand Here */}</div>
        <ul className="flex justify-center space-x-6 text-sm font-semibold">
          {/* <li>
          <button onClick={() => navigate('/')} 
          className="min-w-[60px]  hover:text-blue-500  cursor-pointer text-center transition duration-200 ">
             <HyperText text="Home"/> 
            <FaHome />
          </button>
        </li> */}
          <li className="relative group">
            <button
              onClick={() => navigate("/")}
              className="text-xl text-gray-700 hover:text-blue-500 min-w-[40px]"
            >
              <FaHome />
            </button>
            <span className="absolute top-full left-1/2 transform -translate-x-1/2 mt-2 px-2 py-1 text-xs text-white bg-black rounded opacity-0 group-hover:opacity-100 transition-opacity duration-200 whitespace-nowrap">
              Home
            </span>
          </li>
          <li className="relative group">
            <button
              onClick={() => navigate("/about")}
              className="text-xl text-gray-700 hover:text-blue-500 min-w-[40px]"
            >
              <FaUser />
            </button>
            <span className="absolute top-full left-1/2 transform -translate-x-1/2 mt-2 px-2 py-1 text-xs text-white bg-black rounded opacity-0 group-hover:opacity-100 transition-opacity duration-200 whitespace-nowrap">
              About Me
            </span>
          </li>

          <li className="relative group">
            <button
              onClick={goToProjects}
              className="text-xl text-gray-700 hover:text-blue-500 min-w-[40px]"
            >
              <FaProjectDiagram />
            </button>
            <span className="absolute top-full left-1/2 transform -translate-x-1/2 mt-2 px-2 py-1 text-xs text-white bg-black rounded opacity-0 group-hover:opacity-100 transition-opacity duration-200 whitespace-nowrap">
              Project
            </span>
          </li>

          <li className="relative group">
            <button
              onClick={() => navigate("/blog")}
              className="text-xl text-gray-700 hover:text-blue-500 min-w-[40px]"
            >
              <FaBlog />
            </button>
            <span className="absolute top-full left-1/2 transform -translate-x-1/2 mt-2 px-2 py-1 text-xs text-white bg-black rounded opacity-0 group-hover:opacity-100 transition-opacity duration-200 whitespace-nowrap">
              Blog
            </span>
          </li>

          <li className="relative group">
            <button
              onClick={() => navigate("/contact")}
              className="text-xl text-gray-700 hover:text-blue-500 min-w-[40px]"
            >
              <FaEnvelope />
            </button>
            <span className="absolute top-full left-1/2 transform -translate-x-1/2 mt-2 px-2 py-1 text-xs text-white bg-black rounded opacity-0 group-hover:opacity-100 transition-opacity duration-200 whitespace-nowrap">
              Contact
            </span>
          </li>
          {/* <li>
          <button
            onClick={() => navigate('/about')}
            className="min-w-[80px]  hover:text-blue-500 cursor-pointer text-center transition duration-200  whitespace-nowrap "
          >
          
            <FaUser />
          </button>
        </li>
        
        <li className="min-w-[60px]  hover:text-blue-500 cursor-pointer text-center transition duration-200">
    
          <FaBlog />
        </li>
        <li className="min-w-[70px]  hover:text-blue-500 cursor-pointer text-center transition duration-200 ">
          
          <FaEnvelope />
        </li> */}
        </ul>
      </nav>
    </div>
  );
};

export default Navbar;

// const Navbar = () => {
//   const [isScrolled, setIsScrolled] = useState(false);
//   const navigate = useNavigate();
//   // Track scroll position to apply the floating island effect
//   useEffect(() => {

//     const handleScroll = () => {
//       if (window.scrollY > 100) {
//         setIsScrolled(true);
//       } else {
//         setIsScrolled(false);
//       }
//     };

//     window.addEventListener("scroll", handleScroll);
//     return () => window.removeEventListener("scroll", handleScroll);
//   }, []);

//   return (
//     <nav
//       className={`nav-bar fixed top-0 left-50 w-full bg-white shadow-md px-8 py-3 transition-all duration-300 ${
//         isScrolled
//           ? "top-4 left-1/2 transform -translate-x-1/2 w-[50%] max-w-4xl rounded-full shadow-lg"
//           : "w-full shadow-md rounded-none"
//       }`}
//     >
//       <div className="navbar-logo">{/* Logo or Brand Here */}</div>
//       <ul
//         className={`nav-links flex justify-center space-x-6 text-gray-700 text-sm font-semibold ${
//           isScrolled ? "text-center" : "justify-between"
//         }`}
//       >
//         <li>
//           <button onClick={() => navigate('/')}
//           className="hover:text-blue-500 cursor-pointer transition duration-200">
//           Home
//           </button>
//         </li>
//         <li>
//           <button
//             onClick={() => navigate('/about')}
//             className="hover:text-blue-500 cursor-pointer transition duration-200"
//           >
//             About Me
//           </button>
//         </li>
//         <li>
//           <button
//             onClick={() => navigate('/demo')}
//             className="hover:text-blue-500 cursor-pointer transition duration-200"
//           >
//             blur-face
//           </button>
//         </li>
//         <li className="hover:text-blue-500 cursor-pointer transition duration-200">
//           Blog
//         </li>
//         <li className="hover:text-blue-500 cursor-pointer transition duration-200">
//           Contact
//         </li>
//       </ul>
//     </nav>
//   );
// };

// export default Navbar;
